<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div *ngIf="!isViewMode && hasLabelViewPermission">
        <button mat-icon-button [matMenuTriggerFor]="labelsMenu">
          <i class="angularjs-fuse-icon icon-label-outline"></i>
        </button>

        <mat-menu #labelsMenu="matMenu" [overlapTrigger]="false">
          <label-selector
            [maintenanceId]="maintenance.id"
            [associatedLabels]="maintenance.labels"
            (wasUpdatedLabels)="wasUpdatedLabels($event)"
            type="maintenance"
          >
          </label-selector>
        </mat-menu>
      </div>

      <h2 class="field-dialog__header__title">{{ maintenance.number }} - {{ maintenance.location.name }}</h2>
    </div>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group
    class="field-dialog__content"
    [(selectedIndex)]="selectedTabIndex"
    (selectedTabChange)="onSelectedTabChange($event)"
  >
    <mat-tab [label]="'general'">
      <disclaimer *ngIf="isViewMode" [message]="'MAINTENANCES.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>

      <ng-template mat-tab-label>
        {{ 'MAINTENANCES.GENERAL' | translate }}
      </ng-template>
      <tab-maintenances #tabMaintenances (getMaintenanceForm)="getForm($event)" (isLoading)="isLoading.emit($event)">
      </tab-maintenances>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tab-label">
          <span>{{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.LABEL' | translate }}</span>
          <span class="tab-label_new-circle"></span>
        </div>
      </ng-template>

      <tab-links [maintenance]="maintenance"></tab-links>
    </mat-tab>

    <mat-tab [label]="'MAINTENANCES.TASKS' | translate">
      <div *ngIf="maintenance.tasks.length" class="tab-badge">{{ maintenance.tasks.length | badge }}</div>
      <tab-tasks></tab-tasks>
    </mat-tab>

    <mat-tab [label]="'MAINTENANCES.TABS.WARRANTIES.TITLE' | translate">
      <ng-template matTabContent>
        <warranties-maintenance-tab
          [hasCreateWarrantyPermission]="hasCreateEditWarrantyPermission"
          [hasEditWarrantyPermission]="hasCreateEditWarrantyPermission"
          [maintenanceTypeId]="
            hasCreateEditWarrantyPermission ? maintenanceForm.get('maintenanceType')?.value?.id : null
          "
          [companyId]="hasCreateEditWarrantyPermission ? maintenanceForm.get('company')?.value?.id : null"
          [maintenanceId]="maintenance.id"
        ></warranties-maintenance-tab>
      </ng-template>
    </mat-tab>

    <ng-container *ngIf="hasPendenciesViewPermission">
      <mat-tab [label]="'MAINTENANCES.TABS.PENDENCIES.TITLE' | translate">
        <div *ngIf="pendenciesTotalCount > 0" class="tab-badge">
          {{ pendenciesTotalCount | badge }}
        </div>
        <ng-template matTabContent>
          <tab-pendencies [maintenance]="maintenance"></tab-pendencies>
        </ng-template>
      </mat-tab>
    </ng-container>

    <mat-tab [label]="'MAINTENANCES.TABS.FORMS.TITLE' | translate">
      <tab-forms></tab-forms>
    </mat-tab>

    <mat-tab [label]="'MAINTENANCES.QUOTATIONS' | translate">
      <div *ngIf="maintenance.quotations.length" class="tab-badge">{{ maintenance.quotations.length | badge }}</div>
      <tab-quotations></tab-quotations>
    </mat-tab>

    <mat-tab [label]="'deadlines'">
      <ng-template mat-tab-label>
        {{ 'MAINTENANCES.DEADLINES' | translate }}
      </ng-template>
      <tab-new-deadline (getDeadlinesForm)="getDeadlinesForm($event)"></tab-new-deadline>
    </mat-tab>

    <mat-tab [label]="'MAINTENANCES.TABS.PRODUCTS.TITLE' | translate">
      <tab-products></tab-products>
    </mat-tab>

    <mat-tab [label]="'MAINTENANCES.TABS.SERVICES.TITLE' | translate">
      <tab-services></tab-services>
    </mat-tab>

    <mat-tab [label]="'comments'">
      <ng-template mat-tab-label>
        {{ 'MAINTENANCES.COMMENTS' | translate }}
      </ng-template>
      <div *ngIf="maintenance.comments.length" class="tab-badge">{{ maintenance.comments.length | badge }}</div>
      <tab-comments #tabComments></tab-comments>
    </mat-tab>

    <mat-tab [label]="'attachments'">
      <ng-template mat-tab-label>
        {{ 'MAINTENANCES.ATTACHMENTS' | translate }}
        <div *ngIf="maintenance.attachments.length" class="tab-badge">
          {{ maintenance.attachments.length | badge }}
        </div>
      </ng-template>
      <tab-attachments></tab-attachments>
    </mat-tab>

    <mat-tab [label]="'logs'">
      <ng-template mat-tab-label>
        {{ 'MAINTENANCES.HISTORIC' | translate }}
      </ng-template>
      <tab-logs></tab-logs>
    </mat-tab>
  </mat-tab-group>

  <div
    class="field-dialog__footer"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    [ngClass]="{ 'no-border': selectedTabIndex === 4 }"
  >
    <button
      [disabled]="!isValidMaintenanceForm || isSavingMaintenance || isViewMode"
      class="field-background"
      mat-raised-button
      (click)="saveMaintenance()"
    >
      {{ 'MAINTENANCES.SAVE' | translate }}
    </button>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
      <a
        *ngIf="maintenance.status !== 'new' && maintenance.status !== 'pending' && maintenance.soUrl"
        [href]="maintenance.soUrl"
        target="_blank"
        mat-icon-button
        rel="noreferrer noopener"
        matTooltip="{{ 'MAINTENANCES.REPORT' | translate }}"
      >
        <i class="angularjs-fuse-icon icon-clipboard-text"></i>
      </a>
      <div *ngIf="maintenance?.id && maintenance.status === 'canceled'" class="archive-unarchive-maintenance">
        <button
          class="__archive"
          *ngIf="!maintenance.archived"
          mat-icon-button
          (click)="archiveMaintenance()"
          matTooltip="{{ 'MAINTENANCES.ARCHIVE' | translate }}"
          [disabled]="!isValidMaintenanceForm || isSavingMaintenance || isViewMode"
        >
          <mat-icon class="__icon">archive</mat-icon>
        </button>

        <button
          class="__unarchive"
          *ngIf="maintenance.archived"
          mat-icon-button
          (click)="unarchiveMaintenance()"
          [disabled]="!isValidMaintenanceForm || isSavingMaintenance || isViewMode"
          matTooltip="{{ 'MAINTENANCES.UNARCHIVE' | translate }}"
        >
          <mat-icon class="__icon">unarchive</mat-icon>
        </button>
      </div>
      <button
        *ngIf="!isViewMode && maintenance.status !== 'canceled'"
        mat-icon-button
        data-cy="cancel-maintenance-button"
        matTooltip="{{ 'MAINTENANCES.CANCEL_MAINTENANCE' | translate }}"
        (click)="openCancelDialog()"
      >
        <i class="angularjs-fuse-icon icon-cancel"></i>
      </button>
      <button
        data-cy="reallocate-maintenance-button"
        *ngIf="
          !isViewMode &&
          (maintenance.status === 'new' ||
            maintenance.status === 'pending' ||
            maintenance.status === 'scheduled' ||
            maintenance.status === 'canceled' ||
            maintenance.status === 'requested' ||
            maintenance.status === 'onNegotiation')
        "
        mat-icon-button
        matTooltip="{{ 'MAINTENANCES.REALLOCATE_MAINTENANCE' | translate }}"
        (click)="openRelocationDialog()"
      >
        <i class="angularjs-fuse-icon icon-swap-vertical"></i>
      </button>
      <button
        data-cy="reopen-maintenance-button"
        *ngIf="!isViewMode && maintenance.status === 'canceled'"
        mat-icon-button
        matTooltip="{{ 'MAINTENANCES.REOPEN' | translate }}"
        (click)="openReopenDialog()"
      >
        <i class="angularjs-fuse-icon icon-replay"></i>
      </button>
    </div>
  </div>
</div>
